import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ProjectPermissions } from 'src/screens/shared/project/permissions/ProjectPermissions'

export const PfKapPermissionsPage = (): ReactElement => {
  const { projectId } = useParams()
  const pf_kap_id = parseInt(projectId as string)
  return <ProjectPermissions baseUrl="/pf-kap" projectId={pf_kap_id} />
}
